(() => {
  if (window.__gsbCartTiers) return;
  window.__gsbCartTiers = true;

  /* ---------- <gsb-tier-bar> : re-renders from live cart data ---------- */
  class GsbTierBar extends HTMLElement {
    money(paise) { return this.dataset.symbol + Math.ceil(paise / 100).toLocaleString('en-IN'); }
    /* Parse "99900:5,149900:10," -> [{amt, pct}] */
    tiers() {
      return this.dataset.tiers.split(',').filter(Boolean).map((t) => { const [amt, pct] = t.split(':'); return { amt: +amt, pct }; });
    }
    render(sub) {
      const tiers = this.tiers(), seg = 100 / tiers.length;
      const prev = +this.dataset.state;
      const state = tiers.filter((t) => sub >= t.amt).length;
      let pct, msg;
      if (state === tiers.length) {
        pct = 100;
        msg = `Yay! You unlocked <strong>${tiers[state - 1].pct}% Off</strong>`;
      } else {
        const lo = state ? tiers[state - 1].amt : 0, next = tiers[state];
        pct = state * seg + ((sub - lo) * seg) / (next.amt - lo);
        msg = `Add <strong>${this.money(next.amt - sub)}</strong> more for <strong>${next.pct}% Off</strong>`;
      }
      this.dataset.state = state;
      this.dataset.sub = sub;
      this.querySelector('.gsb-tier__fill').style.width = pct + '%';
      this.querySelector('.gsb-tier__truck').style.left = pct + '%';
      const fd = this.querySelector('.gsb-tier__fd');
      if (fd) fd.classList.toggle('is-reached', sub >= +fd.dataset.amt);
      this.querySelector('.gsb-tier__msg').innerHTML = msg;
      this.querySelectorAll('[data-stop]').forEach((el) => el.classList.toggle('is-reached', state >= +el.dataset.stop));
      return state > prev;
    }
  }
  if (!customElements.get('gsb-tier-bar')) customElements.define('gsb-tier-bar', GsbTierBar);

  /* Confetti ribbon burst: simple & small, triggers ONLY when coupon is applied */
  const blast = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const colors = ['#ff3366', '#ff9900', '#22c55e', '#3b82f6', '#a855f7', '#eab308'];
    const wrap = document.createElement('div');
    wrap.className = 'gsb-ribbons';
    for (let i = 0; i < 48; i++) {
      const c = colors[i % colors.length];
      const isStrip = i % 2 === 0;
      const r = document.createElement('i');
      r.className = isStrip ? 'gsb-ribbon--strip' : 'gsb-ribbon--dot';
      r.style.background = c;
      r.style.cssText += `left:${10 + Math.random() * 80}%;` +
        `--h:${45 + Math.random() * 35}vh;--x:${(Math.random() - 0.5) * 30}vw;--r:${(Math.random() - 0.5) * 720}deg;` +
        `animation-delay:${Math.random() * 0.2}s;animation-duration:${1.5 + Math.random() * 0.6}s`;
      wrap.appendChild(r);
    }
    document.body.appendChild(wrap);
    setTimeout(() => wrap.remove(), 2400);
  };

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      refreshTotals();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          if (syncGift(cart)) return; // the gift add/remove triggers its own refresh
          if (syncBox(cart)) return;
          document.querySelectorAll('gsb-tier-bar').forEach((el) => { el.render(cart.items_subtotal_price); });
        })
        .catch(() => {});
    }, 150);
  };

  /* Update the bar after ANY cart change (drawer, product page, upsell) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const p = nativeFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh).catch(() => {});
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (/\/cart\/(add|change|update|clear)/.test(url)) this.addEventListener('loadend', refresh);
    return xhrOpen.call(this, method, url, ...rest);
  };

  /* ---------- Re-render the cart UI from the same request (no 2nd fetch, no page reload) ----------
     The drawer is rendered on every page (also /cart), so both the drawer and the cart page
     sections are requested when they exist. */
  const cartSections = () => {
    const ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return { sections: ids, sections_url: window.location.pathname };
  };
  /* ---------- Free gift: auto-added when a trigger-size item is in the cart, auto-removed when none is left ----------
     Only lines added by this code (hidden property _gsb_gift) are ever removed. */
  let giftBusy = false;
  const syncGift = (cart) => {
    const g = window.gsbGift;
    if (!g || giftBusy) return false;
    const size = g.size.toLowerCase().replace(/\s/g, '');
    // Trigger = a 100 ml PERFUME (product name contains g.titleHas). Room sprays, cooler/pet perfumes and diffuser
    // oils also come in 100 ml but the free-pack discount doesn't cover them, so the pack would be charged ₹299.
    const need = (g.titleHas || '').toLowerCase();
    const trigger = cart.items.some((i) => i.variant_id !== g.variant
      && (i.variant_title || '').toLowerCase().replace(/\s/g, '').includes(size)
      && (!need || (i.product_title || '').toLowerCase().includes(need)));
    const auto = cart.items.find((i) => i.properties && i.properties._gsb_gift);
    // Gift made free by the discount without a trigger-size item (e.g. 2 x 50ml): not allowed, take it out
    const freeGift = cart.items.find((i) => i.variant_id === g.variant && i.final_line_price === 0);
    let body;
    const inCart = cart.items.some((i) => i.variant_id === g.variant);
    // Customer removed the gift with the x: don't add it back until the cart has no trigger item
    let declined = false;
    try { if (!trigger) sessionStorage.removeItem('gsbGiftOff'); declined = !!sessionStorage.getItem('gsbGiftOff'); } catch (e) {}
    // Skip code on the cart (₹299 off instead of the pack): no pack; code removed: the pack comes back
    if (g.skipCode) declined = (cart.discount_codes || []).some((c) => c.code.toUpperCase() === g.skipCode.toUpperCase());
    if (trigger && !inCart && !declined) body = { url: '/cart/add.js', data: { items: [{ id: g.variant, quantity: 1, properties: { _gsb_gift: '1' } }] } };
    else if (!trigger && (auto || freeGift)) body = { url: '/cart/change.js', data: { id: (auto || freeGift).key, quantity: 0 } };
    if (!body) return false;
    giftBusy = true;
    fetch(body.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body.data, ...cartSections() }),
    })
      .then((r) => r.json())
      .then((d) => renderSections(d.sections))
      .catch(() => {})
      .finally(() => { giftBusy = false; });
    return true;
  };
  /* ---------- "box-product" (₹0): exactly one while the cart has 5+ 2 ml testers from any page, none otherwise ----------
     Gives tester-box orders their own product name (GoKwik Engage automations). */
  let boxBusy = false;
  let boxFails = 0; // stop after 2 refused requests, so a refused box can't loop
  const syncBox = (cart) => {
    const b = window.gsbBox;
    if (!b || boxBusy || boxFails >= 2) return false;
    const units = cart.items.reduce((n, i) => n + ((i.variant_title || '').toLowerCase().replace(/\s/g, '') === '2ml' ? i.quantity : 0), 0);
    const testers = units >= (b.min || 5);
    const boxes = cart.items.filter((i) => i.variant_id === b.variant);
    let body;
    if (testers && !boxes.length) body = { url: '/cart/add.js', data: { items: [{ id: b.variant, quantity: 1, properties: { _gsb_box: '1' } }] } };
    else if (boxes.length > 1 || (boxes.length && !testers)) body = { url: '/cart/update.js', data: { updates: Object.fromEntries(boxes.map((l, n) => [l.key, testers && n === 0 ? 1 : 0])) } };
    else if (boxes.length && boxes[0].quantity !== 1) body = { url: '/cart/change.js', data: { id: boxes[0].key, quantity: 1 } };
    if (!body) return false;
    boxBusy = true;
    fetch(body.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body.data, ...cartSections() }),
    })
      .then((r) => r.json().then((d) => { if (!r.ok || d.status) throw d; return d; }))
      .then((d) => renderSections(d.sections))
      .catch(() => { boxFails += 1; })
      .finally(() => { boxBusy = false; });
    return true;
  };
  // Also check once on page load (e.g. a 50ml item was added on the product page before)
  setTimeout(refresh, 300);

  /* Footer "Est. Total" boxes only: safe to run after ANY cart change (doesn't touch the items being edited) */
  const refreshTotals = () => {
    const { sections } = cartSections();
    fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
      .then((r) => r.json())
      .then((html) => {
        const fresh = Object.values(html).flatMap((h) => [...new DOMParser().parseFromString(h || '', 'text/html').querySelectorAll('.gsb-drawer-foot__total')]);
        document.querySelectorAll('.gsb-drawer-foot__total').forEach((el, i) => { if (fresh[i]) el.innerHTML = fresh[i].innerHTML; });
      })
      .catch(() => {});
  };
  const renderSections = (sections) => {
    if (!sections) return;
    const parse = (h) => new DOMParser().parseFromString(h, 'text/html');
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
        const t = document.querySelector(sel), n = doc.querySelector(sel);
        if (t && n) t.replaceWith(n);
      });
    }
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id), html = el && sections[el.dataset.id];
      const target = html && el.querySelector('.js-contents'), source = html && parse(html).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const n = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (n) bubble.innerHTML = n.innerHTML;
    }
  };

  /* ---------- Featured coupon card (above Recommended For You) ---------- */
  const couponMsg = (m, text, ok) => {
    if (!m) return; // ponytail: code box has no message line; errors are silent, add one if needed
    m.hidden = false;
    m.textContent = text;
    m.classList.toggle('is-ok', !!ok);
  };
  const post = (url, data) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then((r) => r.json());
  /* Used by the coupon cards and the "Enter coupon code" box. m = the message line to fill */
  const applyCoupon = (btn, code, m) => {
    btn.disabled = true;
    let prev = '';
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        prev = (c.discount_codes || []).filter((x) => x.applicable).map((x) => x.code).join(',');
        return post('/cart/update.js', { discount: code, ...cartSections() });
      })
      .then((cart) => {
        const d = (cart.discount_codes || []).find((x) => x.code.toLowerCase() === code.toLowerCase());
        if (!d || !d.applicable) throw new Error(`"${code}" is not valid for this cart`);
        btn.classList.add('is-applied');
        btn.textContent = 'Applied ✓';
        couponMsg(m, `"${d.code}" applied!`, true);
        blast();
        setTimeout(() => renderSections(cart.sections), 700);
      })
      .catch((err) => {
        btn.disabled = false;
        btn.classList.remove('is-applied');
        btn.textContent = 'Apply';
        couponMsg(m, err.message || 'Could not apply this coupon. Please try again.');
        // Shopify swaps the cart's codes for the new one even when it is invalid: put the working ones back
        post('/cart/update.js', { discount: prev }).catch(() => {});
      });
  };
  const applyTyped = (row) => {
    const btn = row.querySelector('[data-gsb-code-apply]');
    const code = row.querySelector('input').value.trim();
    if (code && !btn.disabled) applyCoupon(btn, code, row.nextElementSibling);
  };
  /* Enter in the code box applies the code (and must not submit the cart form around it) */
  document.addEventListener('keydown', (e) => {
    const row = e.key === 'Enter' && e.target.closest && e.target.closest('[data-gsb-code]');
    if (!row) return;
    e.preventDefault();
    applyTyped(row);
  });
  /* x on the "applied" strip: removes the discount codes ("" = none) and any free-gift line (ends GSB100) */
  const removeCoupon = (btn) => {
    btn.disabled = true;
    const keys = (btn.dataset.giftKeys || '').split(',').filter(Boolean);
    const updates = {};
    keys.forEach((k) => { updates[k] = 0; });
    if (keys.length) { try { sessionStorage.setItem('gsbGiftOff', '1'); } catch (e) {} }
    post('/cart/update.js', { discount: '', updates, ...cartSections() })
      .then((cart) => renderSections(cart.sections))
      .catch(() => { btn.disabled = false; });
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gsb-coupon-feature [data-gsb-coupon-apply]');
    if (btn && !btn.disabled) applyCoupon(btn, btn.dataset.code.trim(), btn.closest('.gsb-coupon-feature').querySelector('.gsb-coupons__msg'));
    const typed = e.target.closest('[data-gsb-code-apply]');
    if (typed) applyTyped(typed.closest('[data-gsb-code]'));
    const rm = e.target.closest('[data-gsb-coupon-remove]');
    if (rm && !rm.disabled) removeCoupon(rm);
  });

  /* ---------- Suggested products: desktop slider arrows (manual only) ---------- */
  const syncArrows = (list) => {
    const slider = list.closest('.gsb-upsell__slider');
    const prev = slider.querySelector('[data-dir="-1"]'), next = slider.querySelector('[data-dir="1"]');
    if (!prev) return;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  };
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('.gsb-upsell__arrow');
    if (!arrow) return;
    const list = arrow.closest('.gsb-upsell__slider').querySelector('.gsb-upsell__list');
    const item = list.querySelector('.gsb-upsell__item');
    list.scrollBy({ left: (item ? item.offsetWidth + 10 : list.clientWidth) * +arrow.dataset.dir });
  });
  document.addEventListener('scroll', (e) => {
    if (e.target.classList && e.target.classList.contains('gsb-upsell__list')) syncArrows(e.target);
  }, true);
  // Sync when the pointer reaches the slider (drawer may have been hidden, so width is unknown until then)
  document.addEventListener('pointerover', (e) => {
    const slider = e.target.closest && e.target.closest('.gsb-upsell__slider');
    if (slider) syncArrows(slider.querySelector('.gsb-upsell__list'));
  });

  /* Size pills: pick a variant -> update price + the "+" button's variant */
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.gsb-upsell__pill');
    if (!pill || pill.disabled) return;
    const card = pill.closest('.gsb-upsell__item');
    card.querySelectorAll('.gsb-upsell__pill').forEach((p) => {
      p.classList.toggle('is-active', p === pill);
      p.setAttribute('aria-pressed', p === pill);
    });
    card.querySelector('.gsb-upsell__add').dataset.variantId = pill.dataset.variantId;
    card.querySelector('.gsb-upsell__now').textContent = pill.dataset.price;
    const was = card.querySelector('.gsb-upsell__was');
    was.textContent = pill.dataset.compare;
    was.hidden = !pill.dataset.compare;
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gsb-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const id = Number(btn.dataset.variantId);
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], ...cartSections() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not add');
        btn.innerHTML = '✓';
        btn.classList.add('is-added');
        renderSections(data.sections);
      })
      .catch((err) => {
        btn.disabled = false;
        alert(err.message || 'Could not add this product. Please try again.');
      });
  });
})();